import { Link } from "react-router-dom";

const footerLinks = {
  navigation: [
    { name: "首页", path: "/" },
    { name: "韩漫", path: "/category/korean" },
    { name: "日漫", path: "/category/japanese" },
    { name: "国漫", path: "/category/chinese" },
    { name: "完结漫画", path: "/category/completed" },
  ],
  categories: [
    { name: "恋爱漫画", path: "/category/romance" },
    { name: "热血漫画", path: "/category/action" },
    { name: "奇幻漫画", path: "/category/fantasy" },
    { name: "搞笑漫画", path: "/category/comedy" },
    { name: "悬疑漫画", path: "/category/horror" },
  ],
  about: [
    { name: "关于我们", path: "/about" },
    { name: "品牌介绍", path: "/about#brand" },
    { name: "用户口碑", path: "/about#reviews" },
    { name: "联系我们", path: "/about#contact" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-background-50/20 flex items-center justify-center">
                <i className="ri-book-read-line text-lg"></i>
              </div>
              <span className="text-lg font-bold font-[family-name:var(--font-heading)]">番茄漫画</span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              免费漫画全集大全，提供完结连载热门韩漫、日漫、国漫高清免费在线阅读，追更最新话，支持离线下载缓存。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-3 text-background-50/90">
              <a href="/" className="hover:underline">快速导航</a>
            </h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-50/70 hover:text-background-50 cursor-pointer transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-3 text-background-50/90">
              <a href="/category/all" className="hover:underline">热门分类</a>
            </h4>
            <ul className="space-y-2">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-50/70 hover:text-background-50 cursor-pointer transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-3 text-background-50/90">
              <a href="/about" className="hover:underline">关于</a>
            </h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-50/70 hover:text-background-50 cursor-pointer transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 cursor-pointer transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 cursor-pointer transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 cursor-pointer transition-colors" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/15 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-50/50">
            &copy; 2024-2026 番茄漫画 FanQieComic.com. All rights reserved.
          </p>
          <div className="flex gap-4 text-sm text-background-50/50">
            <a href="#" className="hover:text-background-50/80 cursor-pointer transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-50/80 cursor-pointer transition-colors">服务条款</a>
            <a href="#" className="hover:text-background-50/80 cursor-pointer transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}